import { DocumentModel } from 'api/documents/documents.model';
import Detail from 'components/Detail';
import useCertificateHelper from 'hooks/useCertificateHelper';
import {
  ADDITIONAL_DETAILS,
  CertificateDetailsModel,
  NESTED_DETAILS,
} from 'models/certificate.model';
import { CATEGORY_TYPE } from 'models/documents.model';

const CertificateDetails = ({
  additionalDetails = {} as CertificateDetailsModel,
  ...document
}: DocumentModel<CertificateDetailsModel>) => {
  const { getLabel, getValueByLabel } = useCertificateHelper();

  switch (document.category) {
    case CATEGORY_TYPE.CHEMISTRY:
      return (
        <>
          <Detail
            label={getLabel(ADDITIONAL_DETAILS.CHEMISTRY_MARKET_NAME)}
            value={additionalDetails[ADDITIONAL_DETAILS.CHEMISTRY_MARKET_NAME]}
          />
          <Detail label={getLabel('chemistryBatchNumber')} value={additionalDetails.productId} />
        </>
      );
    case CATEGORY_TYPE.BATTERY_PACKS:
      return (
        <>
          <Detail
            label={getLabel(NESTED_DETAILS.BATTERY_CELL_MODEL)}
            value={getValueByLabel(
              NESTED_DETAILS.BATTERY_CELL_MODEL,
              additionalDetails[ADDITIONAL_DETAILS.DETAILS]
            )}
          />
          {getValueByLabel(
            NESTED_DETAILS.BATTERY_PACK_SERIAL_NUMBER,
            additionalDetails[ADDITIONAL_DETAILS.DETAILS]
          ) && (
            <Detail
              label={getLabel(NESTED_DETAILS.BATTERY_PACK_SERIAL_NUMBER)}
              value={getValueByLabel(
                NESTED_DETAILS.BATTERY_PACK_SERIAL_NUMBER,
                additionalDetails[ADDITIONAL_DETAILS.DETAILS]
              )}
            />
          )}
        </>
      );
    case CATEGORY_TYPE.BATTERY_TECH_REVIEW:
    case CATEGORY_TYPE.BATTERY_PACKS_REPAIR:
    case CATEGORY_TYPE.BATTERY_PACKS_RECYCLING:
    case CATEGORY_TYPE.BATTERY_WASTE:
    case CATEGORY_TYPE.BATTERY_REPURPOSE:
    case CATEGORY_TYPE.BATTERY_CELLS:
      return (
        <>
          <Detail
            label={getLabel(NESTED_DETAILS.BATTERY_CELL_MODEL)}
            value={getValueByLabel(
              NESTED_DETAILS.BATTERY_CELL_MODEL,
              additionalDetails[ADDITIONAL_DETAILS.DETAILS]
            )}
          />
          <Detail label={getLabel('cellsBatchNumber')} value={additionalDetails.productId} />
        </>
      );
    default:
      return (
        <Detail label={getLabel('chemistryBatchNumber')} value={additionalDetails.productId} />
      );
  }
};

export default CertificateDetails;
